<template>
  <div class="md-content">
    <div class="md-layout md-gutter">
      <div class="md-layout-item">
        <div>
          <md-autocomplete
            :value="value"
            :md-options="template_list"
            @md-selected="setTemplate"
            @md-changed="getTemplate"
            @md-opened="getTemplate"
          >
            <label>{{ label }}</label>
            <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.title }}</template>
          </md-autocomplete>
        </div>
      </div>
      <div class="md-layout-item md-size-30">
        <md-button @click="loadTemplate" class="md-raised md-accent">Load</md-button>
      </div>
    </div>
  </div>
</template>
<script>
import HelpersMixin from '../../../HelpersMixin';

export default {
  name: "FbTemplate",
  mixins: [HelpersMixin],
  data() {
    return {
      showMenu: false,
      value: "",
      label: "Template",
      template: {},
      template_list: []
    };
  },
  methods: {
    getTemplate(searchTerm) {
      let self = this;
      this.template_list = new Promise(resolve => {
        if (!searchTerm) {
          resolve([]);
          return;
        }
        const node = searchTerm.toLowerCase();
        const content_manager_groups = drupalSettings.user.content_manager_groups;
        let requestUri = "/jsonapi/webform_template/webform_template?filter[title][condition][path]=title&filter[title][condition][value]=" +
          node +
          "&filter[title][condition][operator]=CONTAINS";
        if (this.isAdministrator() != true) {
          if (content_manager_groups && Object.keys(content_manager_groups).length) {
            requestUri += '&filter[field_group_user][group][conjunction]=OR';
            requestUri += '&filter[field_group][condition][path]=field_group.id&';
            Object.keys(content_manager_groups).forEach((value, index) => {
              requestUri += '&filter[field_group][condition][value][' +index +']=' + value;
            });
            requestUri += '&filter[field_group][condition][operator]=IN';
            requestUri += '&filter[field_group][condition][memberOf]=field_group_user';
            requestUri += "&filter[uid][condition][path]=uid.id";
            requestUri += "&filter[uid][condition][value]=" + window.drupalSettings.user.uuid;
            requestUri += "&filter[uid][condition][memberOf]=field_group_user";
          }
          else {
            requestUri += "&filter[uid.id][value]=" + window.drupalSettings.user.uuid;
          }
        }
        fetch(
          requestUri
        )
          .then(res => {
            return res.json();
          })
          .then(json => {
            window.dispatchEvent(new Event("resize"));
            resolve(
              json.data.map(el => {
                return {
                  id: el.attributes.drupal_internal__tid,
                  title: el.attributes.title,
                  json: el.attributes.template
                };
              })
            );
          })
          .catch(() => {
            resolve([]);
          });
      });
    },
    setTemplate(event) {
      window.setTimeout(() => {
        this.value = event.title;
      }, 0);
      this.template = event;
    },
    loadTemplate() {
      if (this.value != "") {
        this.$emit("load-template", this.template.json);
      }
    },
    getType() {
      if (!document.querySelector("#edit-field-type")) {
        return false;
      }
      return document.querySelector("#edit-field-type").value;
    }
  }
};
</script>
<style lang="scss" scoped>
.md-no-bt-margin {
  margin-bottom: 0;
}
.md-margin-bt {
  margin: 4px 0 4px;
}
.shake-on-error /deep/ .md-duplicated {
  animation-name: shake;
  animation-duration: 0.5s;
}

@keyframes shake {
  0% {
    transform: translate(15px);
  }
  20% {
    transform: translate(-15px);
  }
  40% {
    transform: translate(7px);
  }
  60% {
    transform: translate(-7px);
  }
  80% {
    transform: translate(3px);
  }
  100% {
    transform: translate(0px);
  }
}
</style>
